module.exports = __webpack_public_path__ + "static/img/14000009.e0f96e81.png";